import { useState } from "react"
import { flushSync } from "react-dom"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import Accordion from "aldoo-ra/Accordion"
import ContactSalesDialog from "../../ContactSalesDialog"

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0)
  const [dialogOpen, setDialogOpen] = useState(false)


  function handleDialogClose() {
    document.documentElement.style.scrollBehavior = "auto"
    flushSync(() => setDialogOpen(false))
    document.documentElement.style.scrollBehavior = ""
  }

  return (
    <>
      <section id="faq" className="relative py-20 md:py-28 scroll-mt-0 lg:scroll-mt-16">
        <CMSRender
          contentType="FAQ Section"
          renderItem={(data) => {
            // Access data from the content property
            const content = data.content || data;

            return (
            <div className="relative z-10 w-full max-w-[860px] mx-auto px-4 md:px-10">
              {/* Header */}
              <div className="text-center mb-12">
                <Typography
                  component="h2"
                  variant="h1"
                  className="text-text mt-4"
                >
                  {data.title}
                </Typography>

                <Typography
                  variant="body1"
                  className="max-w-2xl mx-auto"
                >
                  {data.subtitle}{" "}

                  <button
                    onClick={() => setDialogOpen(true)}
                    className="text-primary hover:underline font-semibold"
                  >
                    {data.cta_btn_label}
                  </button>
                  .
                </Typography>
              </div>

              {/* FAQ accordion */}
              <div className="w-full max-w-[900px] mx-auto">
                <Accordion
                  variant="snap"
                  items={content?.questions?.map(question => ({
                    question: question.content?.title || question.title,
                    answer: question.content?.answer || question.answer
                  }))}
                />
              </div>
            </div>
          )
          }}
        />
      </section>

      <ContactSalesDialog isOpen={dialogOpen} onClose={handleDialogClose} />
    </>
  )
}
